import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MyAccountService } from '../../services/myAccount.service';
import { ActiveUserViewModel, UsersViewModel, CurrentUserModel, UserInfoViewModel } from '../../models/account-ledger.model';
import { AuthService } from '../../services/auth.service';
import { CommonService } from '../../services';
import { ApiResponse } from '../../models/api-response.model';

@Component({
  selector: 'app-catalogue-subscriptions-v2',
  templateUrl: './catalogue-subscriptions-v2.component.html',
  styleUrls: ['./catalogue-subscriptions-v2.component.css']
})
export class CatalogueSubscriptionsV2Component implements OnInit {
  title = 'Subscriptions';
  loadContent = false;

  activeUser: ActiveUserViewModel;
  checkedPromotions: boolean;
  checkedDatafeedsCsv: boolean;

  usersList: ActiveUserViewModel[];

  currentUserModel: CurrentUserModel;

  userInfo: UserInfoViewModel;

  accountId: string;
  loginName: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  adminChecked: boolean;
  purchaseChecked: boolean;
  checkedDatafeedsXml: boolean;
  checkedOrderConfirmations: boolean;
  checkedInvoices: boolean;
  checkedOrderStatusUpdates: boolean;
  checkedBackorderETAUpdates: boolean;
  checkedAnnuityExpiryNotifications: boolean;
  checkedShippingReports: boolean;
  checkedStatements: boolean;
  constructor(
    private router: Router,
    private myAccountService: MyAccountService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private commonService: CommonService
  ) { }

  ngOnInit() {

    this.loadContent = false;
    if (this.router.url.includes('catalogueedit')) {
      $('.child-loader').animate({ scrollLeft: $('#catalogueedit').width() }, 400);
    } if (this.router.url.includes('catalogues')) {
      $('.child-loader').animate({ scrollLeft: $('#cataloguelist').width() }, 400);
    }
    // get login user information
    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.currentUserModel = res;
      // get users list subscription information
      this.myAccountService.GetUsers().subscribe((data: UsersViewModel) => {
        if (data && data.activeUsers.length) {
          this.usersList = data.activeUsers;
          // get login user subscriptions information
          // tslint:disable-next-line:no-shadowed-variable
          this.usersList.forEach(element => {
            if (element.loginName.toLowerCase() === this.currentUserModel.loginId.toLowerCase()) {
              this.activeUser = element;
              this.checkedPromotions = this.activeUser.promotions.toLowerCase() === 'y' ? true : false;
              this.checkedDatafeedsCsv = this.activeUser.datafeedCSV.toLowerCase() === 'y' ? true : false;
              this.loadContent = true;
            }
          });
        }
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    });
  }

  update(): void {
    this.loadContent = false;
    this.userInfo = {
      loginName: this.activeUser.loginName,
      accountId: '',
      firstName: this.activeUser.firstName,
      lastName: this.activeUser.lastName,
      email: this.activeUser.email,
      password: this.activeUser.newPassword,
      roles: '',
      mfaEnabled: '',
      isAdmin: this.adminChecked,
      isPurchaseOfficer: this.purchaseChecked,
      promotions: this.checkedPromotions,
      dataFeed: this.checkedDatafeedsCsv,
      stockCatalogue: this.checkedDatafeedsXml,
      invoices: this.checkedInvoices,
      orderConfs: this.checkedOrderConfirmations,
      orderStatusUpdates: this.checkedOrderStatusUpdates,
      etaUpdates: this.checkedBackorderETAUpdates,
      annuityExpireUpdates: this.checkedAnnuityExpiryNotifications,
      shippingReports: this.checkedShippingReports,
      statements: this.checkedStatements
    };
    this.myAccountService.UpdateUserProfile(this.userInfo).subscribe((res: ApiResponse) => {
      if (res.status) {
        this.commonService.implementToast(res.responseMessage, 'Success');
      } else {
        this.commonService.implementToast(res.responseMessage, 'Error');
      }
      this.loadContent = true;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close(): void {
    $('.child-loader').animate({ scrollLeft: -$('.seclevel').width() }, 400);
    this.router.navigate(['../'], {relativeTo: this.activatedRoute});
  }
}
